import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, ActivatedRoute } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { KeycloakAuthService } from "../_services/keycloak-auth.service";
import { RbacService } from "../_services/rbac.service";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(private _router: Router, private _userService: UserService, private _route: ActivatedRoute, private keycloakAuthService: KeycloakAuthService, private rbacService: RbacService) {
        if (!this.keycloakAuthService.isEnabled()) {
            this.checkIsValid();
        }
    }

    private deleteCookie(value: string) {
        document.cookie = value + "=;-1;path=/";
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let verified = this._userService.verify();
        let auth_error: any = this._route.snapshot.queryParams['error'];
        let saved_auth_error: any = localStorage.getItem('auth_error');

        if (verified) {
            if (!this.rbacService.canAccessRoute(state.url)) {
                this._router.navigate([this.rbacService.firstAllowedRoute()]);
                return false;
            }
            return true;
        }
        else {
            if (this.keycloakAuthService.isEnabled()) {
                if (this.keycloakAuthService.hasAuthenticatedSession() && !this.keycloakAuthService.hasRequiredRole()) {
                    this._router.navigate(['/login'], {
                        queryParams: { returnUrl: state.url, accessDenied: 'role' }
                    });
                    return false;
                }
                this.keycloakAuthService.login(this.buildRedirectUrl(state.url));
                return false;
            }

            // If authentication was made with external login (e.g. Google) redirect to logout to clear session
            if ((+localStorage.getItem('external')) === 1) {
                if (!auth_error && !saved_auth_error) localStorage.clear();
                window.location.href = this.buildExternalLogoutUrl();
            } else {
                if (!auth_error && !saved_auth_error) localStorage.clear();
                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            }
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return this.canActivate(route, state);
    }

    checkIsValid() {
        if (this.keycloakAuthService.isEnabled()) {
            return;
        }

        let verified = this._userService.verify();
        let auth_error: any = this._route.snapshot.queryParams['error'];
        let saved_auth_error: any = localStorage.getItem('auth_error');
        if (verified) {
            setTimeout(() => {
                this.checkIsValid();
            }, 10000);
        }
        else {
            // If authentication was made with external login (e.g. Google) redirect to logout to clear session
            if ((+localStorage.getItem('external')) === 1) {
                if (!auth_error && !saved_auth_error) localStorage.clear();
                window.location.href = this.buildExternalLogoutUrl();
            } else {
                if (!auth_error && !saved_auth_error) localStorage.clear();
                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login']);
            }
        }
    }

    // private buildRedirectUrl(path: string): string {
    //     if (!path) {
    //         return window.location.origin + '/';
    //     }

    //     if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0) {
    //         return path;
    //     }

    //     return window.location.origin + '/' + path.replace(/^\/+/, '');
    // }

    private buildRedirectUrl(path: string): string {
    if (!path) {
        return document.baseURI;
    }

    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    return new URL(path.replace(/^\/+/, ''), document.baseURI).href;
}

    private buildExternalLogoutUrl(): string {
        let appUrl = new URL('login/', document.baseURI).href;
        return `${environment.ConfigEndpoints["login"]}logout?app_url=${encodeURIComponent(appUrl)}`;
    }
}
